import { TextProps } from "@chakra-ui/react";

export const FONT_WEIGHTS = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};

export type textStylesType =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "subhead1"
  | "labels"
  | "body1"
  | "body1semibold"
  | "body2"
  | "body2semibold"
  | "body3"
  | "body3semibold"
  | "body4"
  | "body4semibold"
  | "body5"
  | "body5semibold"
  | "table1"
  | "table2"
  | "button1"
  | "button2";

export const TEXT_STYLES: { [key in textStylesType]: TextProps } = {
  h1: {
    fontSize: ["40px", null, "48px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "h1",
    fontWeight: FONT_WEIGHTS.regular
  },
  h2: {
    fontSize: ["34px", null, "40px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "h2",
    fontWeight: FONT_WEIGHTS.regular
  },
  h3: {
    fontSize: ["28px", null, "34px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "h3",
    fontWeight: FONT_WEIGHTS.regular
  },
  h4: {
    fontSize: ["22px", null, "28px"],
    lineHeight: ["28px", null, "36px"],
    letterSpacing: "normal",
    as: "h4",
    fontWeight: FONT_WEIGHTS.regular
  },
  h5: {
    fontSize: ["18px", null, "22px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "h5",
    fontWeight: FONT_WEIGHTS.semibold
  },
  h6: {
    fontSize: ["16px", null, "18px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "h6",
    fontWeight: FONT_WEIGHTS.semibold
  },
  subhead1: {
    fontSize: ["14px", null, "14px"],
    lineHeight: "normal",
    letterSpacing: "0.04em",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  labels: {
    fontSize: ["12px", null, "12px"],
    lineHeight: "normal",
    letterSpacing: "0.04em",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  body1: {
    fontSize: ["18px", null, "22px"],
    lineHeight: ["24px", null, "28px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  },
  body1semibold: {
    fontSize: ["18px", null, "22px"],
    lineHeight: ["24px", null, "28px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  body2: {
    fontSize: ["16px", null, "18px"],
    lineHeight: ["20px", null, "24px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  },
  body2semibold: {
    fontSize: ["16px", null, "18px"],
    lineHeight: ["20px", null, "24px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  body3: {
    fontSize: ["14px", null, "16px"],
    lineHeight: ["18px", null, "20px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  },
  body3semibold: {
    fontSize: ["14px", null, "16px"],
    lineHeight: ["18px", null, "20px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  body4: {
    fontSize: ["12px", null, "14px"],
    lineHeight: ["16px", null, "18px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  },
  body4semibold: {
    fontSize: ["12px", null, "14px"],
    lineHeight: ["16px", null, "18px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  body5: {
    fontSize: ["10px", null, "12px"],
    lineHeight: ["14px", null, "16px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  },
  body5semibold: {
    fontSize: ["10px", null, "12px"],
    lineHeight: ["14px", null, "16px"],
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  button1: {
    fontSize: ["16px", null, "16px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  button2: {
    fontSize: ["14px", null, "14px"],
    lineHeight: "normal",
    letterSpacing: "normal",
    as: "p",
    fontWeight: FONT_WEIGHTS.semibold
  },
  table1: {
    fontSize: ["14px", null, "14px"],
    lineHeight: "normal",
    letterSpacing: "0.05em",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  },
  table2: {
    fontSize: ["12px", null, "12px"],
    lineHeight: "normal",
    letterSpacing: "0.05em",
    as: "p",
    fontWeight: FONT_WEIGHTS.regular
  }
};
